<script type="text/javascript">
// 定义一些公共的属性和方法
// const httpUrl = 'http://127.0.0.1:80/'
const httpUrl = process.env.VUE_APP_ASSET
// 暴露出这些属性
export default {
  httpUrl
}
</script>
